// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-page-event-holidays{position:relative;margin-bottom:5px;border-radius:3px;padding:3px;vertical-align:middle;overflow-x:hidden;overflow-y:hidden}.calendar-page-event-holidays__edit-panel{position:absolute;right:2px;top:2px;padding:3px;border-radius:3px;background-color:rgba(255,255,255,0.5)}.calendar-page-event-holidays a{color:#333}@media (min-width: 375px){.calendar-page-event-holidays{font-size:16px}}.calendar-page-event-holidays i.fa{font-size:22px}\n", ""]);
// Exports
module.exports = exports;
